import type { AxiosResponse } from 'axios';
import { apiClient } from '@/shared/api';
import { handleRequest } from '@/shared/api/apiWrapper.ts';

export type InvoiceFileType = 'pdf' | 'html';

export const getInvoiceFileRequest = async (
  invoiceId: string,
  fileType: InvoiceFileType
): Promise<AxiosResponse<Blob | string>> => {
  const accept = fileType === 'pdf' ? 'application/pdf' : 'text/html';

  const urlParams = new URLSearchParams({
    responseType: 'file',
  });

  const request = () =>
    apiClient.get(
      `/operations/bank/deposit/invoices/${invoiceId}/${fileType}${fileType === 'pdf' ? `?${urlParams}` : ''}`,
      {
        headers: { Accept: accept },
        responseType: fileType === 'pdf' ? 'blob' : undefined,
      }
    );

  return await handleRequest<Blob | string>(request);
};
